import { observer } from 'mobx-react';
import { useNavigate, useParams, } from 'react-router-dom';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
import Helper, { formatDate} from '../../../../core/services/Helper';
import { Icon } from '../../../../core/components/Icon';
import { useState } from 'react';
import { has } from 'mobx';

const SavedEstimates = observer(() => {
  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  vm.navigate = useNavigate();
  let { memberId } = useParams();

  // Tracking whether there is an instance of an estimate with multiple leave periods:
  const hasMultipleLeavePeriods =
  vm.savedEstimates?.some(
    (estimate) => estimate.spcRequestCount && estimate.spcRequestCount > 1
  ) ?? false;


  return (
    <>
      <table className='min-w-[850px] w-full table-auto'>
      <thead className="border-b-[2px] bg-[#FFFFFF] border-[#EAECF1]">
        <tr>  
          <th className="text-left p-3 text-[#333333] border-b border-neutral-300 w-[80px] h-[43px]" style={{width:'110px'}}>ID</th>
          <th className="text-left p-3 text-[#333333] border-b border-neutral-300 w-[150px] h-[43px]">CREATED ON</th>
          <th className="text-left p-3 text-[#333333] border-b border-neutral-300 w-[305px] h-[43px]">TYPE OF SERVICE CREDIT</th>
          <th className="text-left p-3 text-[#333333] border-b border-neutral-300 w-[125px] h-[43px]">START DATE</th>
          <th className="text-left p-3 text-[#333333] border-b border-neutral-300 w-[105px] h-[43px]">END DATE</th>
          <th className="text-center p-3 text-[#333333] border-b border-neutral-300 w-[135px] h-[43px]">AMOUNT</th>
        </tr> 
      </thead>
      <tbody>
        {vm.savedEstimates && vm.savedEstimates.length > 0 ? vm.savedEstimates.map((estimate, index) => (
          <tr key={`estimateRow${index}`} 
          style={{cursor:'pointer'}}
          onClick={async (e: React.MouseEvent<HTMLTableRowElement>) => {
                  const target = e.target as HTMLElement;
                  if (target.closest('td.excluded-column')) {
                    console.log("In return statement.");
                    return;
                  }
                  await vm.editSavedEstimateAsync(memberId!,estimate.spcTypeSubId!,estimate.spcTypeId!)
          }}>
            <td className="p-3 border-b border-neutral-300">SPC-{estimate.spcTypeSubId!}{estimate.spcRequestCount && estimate.spcRequestCount > 1 ? <sup>*</sup>:''}</td>
            <td className="p-3 border-b border-neutral-300">{formatDate(estimate.createDate)}</td>
            <td className="p-3 border-b border-neutral-300">{estimate.typeOfServiceCredit}</td>
            <td className="p-3 border-b border-neutral-300">{formatDate(estimate.startDate)}</td>
            <td className="p-3 border-b border-neutral-300">{formatDate(estimate.endDate)}</td>
            <td className="p-3 border-b border-neutral-300 text-right whitespace-nowrap">
              <div className="inline-flex items-center gap-2">
                <span>{Helper.formatCurrency(estimate.amount)}</span>

                <span
                className="cursor-pointer"
                onClick={async (e) => {
                  e.stopPropagation(); 
                  e.preventDefault();

                  Appl.ConfirmBox.show(
                    'If you proceed, this estimate will be permanently removed. You will need to create a new estimate if you want it again later.',
                    'Are You Sure You Wish to Delete?',
                    '',
                    "Yes, I am sure",
                    "Cancel",
                    async () => await vm.onDeleteSavedEstimateAsync(estimate.spcTypeSubId!),
                    undefined,
                    true
                  );
                }}
              >

                  <svg
                    width="23"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 transition-colors duration-200"
                    style={{ transition: "fill 0.2s ease-in-out" }}
                    onMouseEnter={(e) => (e.currentTarget.querySelector('path')!.style.fill = "#949494")}
                    onMouseLeave={(e) => (e.currentTarget.querySelector('path')!.style.fill = "#949494")}
                  >
                    <path
                      d="M5.11875 0H8.88125C9.25938 0 9.60625 0.2125 9.775 0.553125L10 1H13C13.5531 1 14 1.44687 14 2C14 2.55312 13.5531 3 13 3H1C0.446875 3 0 2.55312 0 2C0 1.44687 0.446875 1 1 1H4L4.225 0.553125C4.39375 0.2125 4.74062 0 5.11875 0ZM1 4H13L12.3375 14.5938C12.2875 15.3844 11.6312 16 10.8406 16H3.15937C2.36875 16 1.7125 15.3844 1.6625 14.5938L1 4ZM4.46875 7.46875C4.175 7.7625 4.175 8.2375 4.46875 8.52812L5.9375 9.99687L4.46875 11.4656C4.175 11.7594 4.175 12.2344 4.46875 12.525C4.7625 12.8156 5.2375 12.8187 5.52812 12.525L6.99687 11.0562L8.46562 12.525C8.75937 12.8187 9.23438 12.8187 9.525 12.525C9.81562 12.2312 9.81875 11.7562 9.525 11.4656L8.05625 9.99687L9.525 8.52812C9.81875 8.23438 9.81875 7.75938 9.525 7.46875C9.23125 7.17812 8.75625 7.175 8.46562 7.46875L6.99687 8.9375L5.52812 7.46875C5.23438 7.175 4.75938 7.175 4.46875 7.46875Z"
                      fill="#949494"
                    />
                  </svg>
                </span>
              </div>
            </td>
          </tr>
        )) : (
          <tr>  
            <td colSpan={7} className="p-3 border-b border-neutral-300 text-center">You don’t have any saved estimates.</td>
          </tr>
        )}
      </tbody>
      </table>
      {hasMultipleLeavePeriods && (
        <div className='mt-[10px] pl-3 text-[13px] tracking-[-1.5%] mb-[10px]'><i><sup>*</sup>This estimate contains multiple leave periods (date ranges).</i></div>
      )}
     </>
  );
});

export default SavedEstimates;
